import * as React from "react";
import { Typography } from "@mui/material";
import { ReactComponent as ExpertSelectionIcon } from "../../../assets/svg/expert-selection.svg";
import { ReactComponent as ProjectBrief } from "../../../assets/svg/project-brief.svg";
import { ReactComponent as Downloads } from "../../../assets/svg/downloads.svg";
import { ReactComponent as RankingIcon } from "../../../assets/svg/expert-selection.svg";

import { useUser } from "../../../hooks/useUser";
import { isInternal } from "../../../utils";

export default function ExpertSelectionSwitcher({ isActive, setIsActive, videoCount, videoTotal = 0, hasExperts = true }) {
  const { role } = useUser();

  const getProps = (key, positionClass) => {
    const isSelected = isActive === key;
    return {
      className: `
        border py-2 px-2 flex justify-center items-center gap-2 flex-1 whitespace-nowrap
        cursor-pointer border-border-token transition-all
        ${positionClass}
        ${isSelected ? "bg-tint" : "bg-surface"}
      `,
    };
  };

  const getTextStyle = (key) => ({
    color: isActive === key ? "var(--accent-text)" : "var(--text-2)",
    fontFamily: "CircularStd",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: isActive === key ? 900 : 450,
    lineHeight: "normal",
  });

  const getIconColor = (key) => ({
    color: isActive === key ? "var(--accent-text)" : "var(--muted)",
  });

  return (
    <div
      className="w-full lg:flex-1 min-w-0 overflow-x-auto"
      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
    >
      <div className="flex rounded-[0.95rem] border border-border-token min-w-max lg:min-w-full">
        <div {...getProps("details", "rounded-l-xl")} onClick={() => setIsActive("details")}>
          <ProjectBrief className="w-6 h-6" style={getIconColor("details")} />
          <Typography sx={getTextStyle("details")}>Project Details</Typography>
        </div>

        {isInternal(role) && hasExperts && (
          <div {...getProps("expertProposals", "")} onClick={() => setIsActive("expertProposals")}>
            <ExpertSelectionIcon className="w-6 h-6" style={getIconColor("expertProposals")} />
            <Typography sx={getTextStyle("expertProposals")}>Expert Proposals</Typography>
          </div>
        )}

        {hasExperts && (
          <div {...getProps("expertRanking", "")} onClick={() => setIsActive("expertRanking")}>
            <RankingIcon className="w-6 h-6" style={getIconColor("expertRanking")} />
            <Typography sx={getTextStyle("expertRanking")}>Expert Selection</Typography>
          </div>
        )}

        <div {...getProps("downloads", "rounded-r-xl")} onClick={() => setIsActive("downloads")}>
          <Downloads className="w-6 h-6" style={getIconColor("downloads")} />
          <Typography sx={getTextStyle("downloads")}>
            Videos{videoTotal > 0 ? ` (${videoCount}/${videoTotal})` : videoCount > 0 ? ` (${videoCount})` : ''}
          </Typography>
        </div>
      </div>
    </div>
  );
}
